import { GAME_PHASES } from "@/game-rules/constants/gamePhases.js";
import { slideLineOfFire } from "@/presentation/renderers/gameSceneRendererLineOfFire.js";
import { playCobblestoneSound } from "@/presentation/renderers/animations/rockImpact.js";
import { getLineSlots, getActionCardsInHand } from "@/presentation/helpers/selectors.js";
import { ACTOR_TAGS } from "@/presentation/helpers/actorTags.js";

export function bindInputEvents(k, gameState) {
    k.onClick(ACTOR_TAGS.LINE_ACTOR, (item) => {
        // ONLY poke if it's the player's turn AND they DO NOT have a card selected!
        if ((gameState.phase === GAME_PHASES.PLAYER_TURN || gameState.phase === GAME_PHASES.INIT) && gameState.selectedCardIndex === null) {
            if (gameState.slotIsProtected(item.slotIndex)){
                playCobblestoneSound(k)
            }else{
                item.poke();
            }
        }
    });

    k.onHover(ACTOR_TAGS.LINE_SLOT, (slot) => {
        const cur = k.get("custom_cursor")[0];
        if (!cur) return;

        if (gameState.selectedCardIndex === null) {
            cur.hoverSlot(true, false);
            return;
        }

        const activePlayer = gameState.getCurrentPlayer();
        const card = activePlayer.hand[gameState.selectedCardIndex];
        const isValid = card.isValidOn(slot.slotIndex, gameState);

        // Check line of fire last index to adapt parameter for secondary cursor
        let suppressSecondary = slot.slotIndex === 5;

        // Card-specific rules
        if (!suppressSecondary && card.typeId === "DOUBLE_VISEUR") {
            const nextSlotHasTarget = gameState.lineOfFireSlots[slot.slotIndex + 1].isTargeted;
            if (nextSlotHasTarget) {
                suppressSecondary = true;
            }
        }

        const lineSlots = getLineSlots(k);
        const nextSlot = lineSlots.find(s => s.slotIndex === slot.slotIndex + 1);
        const nextSlotPos = nextSlot ? k.vec2(nextSlot.pos.x, nextSlot.pos.y) : null;

        cur.hoverSlot(isValid, suppressSecondary, nextSlotPos);
    });

    // Hover end on target slot
    k.onHoverEnd(ACTOR_TAGS.LINE_SLOT, (slot) => {
        const cur = k.get("custom_cursor")[0];
        if (cur) cur.clearHover();
    });

    // Click outside to deselect cards
    k.onMousePress(() => {
        const playerHand = getActionCardsInHand(k);
        const lineSlots = getLineSlots(k);
        const mousePos = k.mousePos();

        // We check if the mouse is currently over ANY card or ANY target.
        const isHoveringSomething = [...playerHand, ...lineSlots].some(obj => obj.hasPoint(mousePos));

        // If the mouse is NOT over a card or target, they clicked the background!
        if (!isHoveringSomething) {
            gameState.deselectCard();
        }
    });

    // ==========================================
    // DEBUG CONTROLS
    // ==========================================
    k.onKeyPress("w", () => {
        // Grab the first player from the State
        const debugWinner = gameState.players[0];

        console.log(`🏆 DEBUG: Forcing Game Over. Winner is ${debugWinner.team.id}`);

        // Transition to the Game Over scene and hand it the winner envelope
        k.go("gameOver", debugWinner);
    });

    k.onKeyPress("0", async () => {
        console.log(gameState)
    });
    k.onKeyPress("1", async () => {
        await slideLineOfFire(k, [0, 1, 2, 3, 4, 5], 1, true);
    });

    k.onKeyPress("x", () => {
        gameState.cheatTargetsOnEverySlots();
    });
}